import React from 'react';
import { ZoomIn, ZoomOut, Maximize2, Grid3x3, Ruler } from 'lucide-react';
import { usePlan } from './PlanContext';

export default function ZoomControls() {
  const { zoom, changeZoom, resetZoom, fitToScreen, snapToGrid, setSnapToGrid, pxPerM, roomWm, roomHm } = usePlan();
  return (
    <div style={{
      position: 'absolute', bottom: 16, right: 16, zIndex: 50,
      display: 'flex', flexDirection: 'column', gap: 4,
      alignItems: 'center',
    }}>
      <button onClick={() => changeZoom(0.1)} title="Zoom +" style={btnStyle}><ZoomIn size={14} /></button>

      <span style={{
        fontSize: 9, fontWeight: 700, color: '#C58B19',
        background: 'rgba(212,175,55,.12)', borderRadius: 6,
        padding: '2px 4px', minWidth: 32, textAlign: 'center',
        fontFamily: "'Montserrat',sans-serif",
      }}>
        {Math.round(zoom * 100)}%
      </span>

      <button onClick={() => changeZoom(-0.1)} title="Zoom -" style={btnStyle}><ZoomOut size={14} /></button>
      <button onClick={fitToScreen} title="Ajuster à l'écran" style={{ ...btnStyle, marginTop: 4 }}><Maximize2 size={12} /></button>
      <button onClick={() => setSnapToGrid(s => !s)} title={snapToGrid ? 'Désactiver snap' : 'Activer snap'}
        style={{ ...btnStyle, background: snapToGrid ? 'rgba(212,175,55,0.15)' : '#fff' }}>
        <Grid3x3 size={12} style={{ color: snapToGrid ? '#C58B19' : '#9CA3AF' }} />
      </button>

      {/* Info échelle */}
      <div style={{
        marginTop: 4, background: 'rgba(255,255,255,0.9)',
        border: '1px solid #E5E7EB', borderRadius: 6,
        padding: '4px 6px', textAlign: 'center',
        fontSize: 8, color: '#6B7280',
        fontFamily: "'Montserrat',sans-serif",
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}>
        <Ruler size={9} style={{ display: 'block', margin: '0 auto 1px' }} />
        {pxPerM}px/m
        <br/>{roomWm}m×{roomHm}m
      </div>
    </div>
  );
}

const btnStyle = {
  width: 30, height: 30, borderRadius: 7,
  background: '#FFFFFF', border: '1px solid #E5E7EB',
  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  color: '#374151', boxShadow: '0 1px 3px rgba(0,0,0,.08)',
};
